import React from 'react'
import classNames from 'classnames'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import {
  CaptionSM,
  CaptionXS,
  EyebrowLG,
  EyebrowMD,
  HeadingLG,
  HeadingMD,
  TitleLG,
  TitleMD,
  TitleSM,
} from '@/atoms/Text'
import { FlexibleBookingToolTip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ToolTips/FlexibleBookingToolTip'
import { SpecificTimesToolTip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ToolTips/SpecificTimesToolTip'
import { CountdownTimer } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/EarlyBirdBanner/CountdownTimer'
import { EarlyBirdContentProps } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/EarlyBirdBanner/EarlyBirdBanner'

export const MediumContent = ({ code, bannerValues, discount, refetch }: EarlyBirdContentProps) => {
  const imageSrc = bannerValues['large'].image
  if (!imageSrc) return null

  return (
    <div className={classNames('relative mb-2 rounded-xl ', bannerValues.bgColor)}>
      <div className=" relative h-full min-h-[160px] w-full rounded-xl @container/banner ">
        <div className={'relative z-0 h-full min-h-[160px] overflow-hidden  rounded-r-xl xl:!min-h-[140px]'}>
          <div className={'absolute left-0 top-0 z-10   h-[160px] w-full min-w-[200px] xl:!h-[140px]'}>
            <div className={'relative flex w-full justify-end'}>
              <div className="w-[250px] bg-[#EAE0D9] lg:w-[400px]" />
              <div className="relative right-0 top-0 z-10 block  h-[160px] w-32 bg-gradient-to-r from-[#EAE0D9] to-transparent  to-100% @[600px]:w-[120px] xl:!h-[140px] " />
              <div className="hidden w-[25px] @[600px]:block @[1000px]:w-[120px]" />
            </div>
          </div>
          <div
            className={
              'relative z-0 hidden h-full min-h-[160px] overflow-hidden  rounded-r-xl @md:block xl:!min-h-[140px]'
            }
          >
            <Image
              src={imageSrc}
              className={`absolute -right-10  top-0 z-[5] h-full w-auto rounded-r-xl  object-contain pr-1 @[45.75em]:h-[190%] @[45.75em]:pr-0 @[1000px]:right-0 `}
              width={200}
              height={200}
              alt={''}
            />
          </div>
        </div>
        {/* Main content container - absolute positioning to fill parent */}
        <div className="item-stretch absolute inset-0 z-10 flex w-[60%] min-w-[600px] justify-start gap-4 rounded-xl px-0 @container/content @[600px]:w-[66%] @[600px]:gap-14">
          {/*First COLUMN*/}
          <FlexColumn className="flex min-w-[230px] justify-center py-2  pl-6">
            <FlexRow className={'justify-center'}>
              <TitleLG className="hidden @[900px]:block" weight={'semibold'} color="black">
                Buy Early. Save Big.
              </TitleLG>
              <TitleMD className="@[900px]:hidden" weight={'semibold'}>
                Buy Early. Save Big.
              </TitleMD>
            </FlexRow>
            <FlexRow className="justify-center pl-0">
              <HeadingLG weight={'bold'} className="hidden uppercase @[56.25em]:block" color={'black'}>
                {discount}% off
              </HeadingLG>
              <HeadingMD className="@[56.25em]:hidden" weight={'bold'} color="black">
                {discount}% off
              </HeadingMD>
            </FlexRow>
            <EyebrowMD weight={'medium'} className="mt-2 text-center uppercase" color="black">
              use code <span className="bg-[#B22E14] px-2 py-1 font-bold text-white">{code}</span>
            </EyebrowMD>
            <div className={'mt-1 flex justify-center'}>
              <FlexibleBookingToolTip
                className="mt-2"
                buttonColor={'gray-800'}
                buttonClassName="bg-none border-[1px] !border-gray-800 text-gray-800 focus-visible:outline-none focus-visible:ring-offset-transparent focus-visible:ring-transparent"
              />
            </div>
          </FlexColumn>
          {/*SECOND COLUMN*/}
          <FlexColumn className="hidden min-w-[250px] items-center  justify-center @[850px]:flex">
            <TitleMD className="hidden text-center @[56.25em]:block" weight="semibold" color="black">
              On Select Showtimes
            </TitleMD>
            <TitleSM className="text-center @[56.25em]:hidden" weight="semibold" color="black">
              On Select Showtimes
            </TitleSM>
            <EyebrowLG weight={'semibold'} className="hidden uppercase opacity-70 @[56.25em]:block" color="black">
              Opening Week (May 22 - 25)
            </EyebrowLG>
            <EyebrowLG weight={'medium'} className="uppercase opacity-70 @[56.25em]:hidden" color="black">
              Opening Week (May 22 - 25)
            </EyebrowLG>
            <div className="flex justify-center">
              <SpecificTimesToolTip buttonClassName="opacity-70 focus-visible:outline-none focus-visible:ring-offset-transparent focus-visible:ring-transparent" />
            </div>
            <CaptionSM className="hidden pt-1 italic @[56.25em]:block" color="core-gray-700">
              Available for Angel Partnering Theaters.
            </CaptionSM>
            <CaptionXS className="pt-1 italic @[56.25em]:hidden" color="core-gray-700">
              Available for Angel Partnering Theaters.
            </CaptionXS>
          </FlexColumn>
          <FlexColumn className=" flex min-w-[250px]  items-center justify-center @[850px]:hidden">
            <TitleSM className="text-center" weight="semibold" color="black">
              On Select Showtimes
            </TitleSM>
            <EyebrowMD weight={'medium'} className="uppercase opacity-70 " color="black">
              Opening Week (Apr. 10 - 17)
            </EyebrowMD>
            <div className="flex justify-center">
              <SpecificTimesToolTip buttonClassName="opacity-70 focus-visible:outline-none focus-visible:ring-offset-transparent focus-visible:ring-transparent" />
            </div>
            <div className="border-none pt-2">
              <CountdownTimer onCountdownEnd={refetch} textColor={'black'} />
            </div>
          </FlexColumn>
          {/*THIRD COLUMN*/}
          <FlexColumn className="hidden  min-w-[175px] items-center  justify-center  @[850px]:flex">
            <div className="border-none pb-2">
              <CountdownTimer onCountdownEnd={refetch} textColor={'black'} />
            </div>
            <FlexibleBookingToolTip
              className="mt-2"
              buttonColor={'gray-800'}
              buttonClassName="bg-none border-[1px] !border-gray-800 text-gray-800 focus-visible:outline-none focus-visible:ring-offset-transparent focus-visible:ring-transparent"
            />
          </FlexColumn>
        </div>
      </div>
    </div>
  )
}
